// components/ui/Switch.tsx — Radix UI Switch toggle wrapper

import * as RadixSwitch from '@radix-ui/react-switch';
import styles from './Switch.module.css';

export interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label?: string;
  description?: string;
  id?: string;
  disabled?: boolean;
}

export function Switch({ checked, onCheckedChange, label, description, id, disabled }: SwitchProps) {
  const switchId = id ?? `switch-${label ? label.replace(/\s+/g, '-').toLowerCase() : 'toggle'}`;

  return (
    <div className={styles.container}>
      {label && (
        <div className={styles.textCol}>
          <label htmlFor={switchId} className={styles.label}>
            {label}
          </label>
          {description && <p className={styles.description}>{description}</p>}
        </div>
      )}
      <RadixSwitch.Root
        id={switchId}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className={styles.root}
      >
        <RadixSwitch.Thumb className={styles.thumb} />
      </RadixSwitch.Root>
    </div>
  );
}
